<ng-container *ngIf="!loading; else loadingBlock">
  <ng-container *ngIf="!loadingError">
    <div *ngIf="content.title" class="partners-logos__header">
      <air-title
        [title]="content.title"
        [region]="region"
        [isFirst]="isFirst"
        [isCentered]="region === contentBlockRegion.primary"
      ></air-title>
    </div>
    <carousel *ngIf="partners.length > 0" [list]="true" [autoSlideInterval]="5000" [showThumbs]="false" [userEventSource]="userEventSource">
      <ng-container *ngFor="let partner of partners">
        <div *carouselSlide>
          <div class="container">
            <a class="partners-logos__link" [airLink]="partner.url" [userEventSource]="userEventSource" [userEventLabel]="partner.title">
              <img class="partners-logos__img" *ngIf="partner.logo" [src]="partner.logo.cropUrl" [alt]="partner.title" />
            </a>
          </div>
        </div>
      </ng-container>
    </carousel>
  </ng-container>
</ng-container>

<ng-template #loadingBlock>
  <div class="partners-logos d--flex loading">
    <a *ngFor="let skeleton of [] | range: 5" class="partners__link">
      <img />
    </a>
  </div>
</ng-template>
